import COUNTRIES from '../countries.translations'

import translations from './gold.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/gold'

export const gold: Metal = {
  id: 18,
  slug: 'gold',
  name: t.name,
  symbol: 'Au',
  // The sheet's six pins replace the earlier placeholder set: Carletonville rather than
  // the Mponeng shaft it sits beside, Tembagapura rather than Grasberg, and Carlin and
  // Crescent Valley as two separate Nevada pins. No operators — the sheet names none.
  mines: [
    {
      name: 'Carletonville (South Africa)',
      region: t.mine0Region,
      slug: 'carletonville',
      coordinates: [27.4, -26.36],
    },
    {
      name: 'Tembagapura (Indonesia)',
      region: t.mine1Region,
      slug: 'tembagapura',
      coordinates: [137.11, -4.11],
    },
    {
      name: 'Carlin (USA)',
      region: t.mine2Region,
      slug: 'carlin',
      coordinates: [-116.11, 40.71],
    },
    {
      name: 'Crescent Valley (USA)',
      region: t.mine3Region,
      slug: 'crescent-valley',
      coordinates: [-116.58, 40.41],
    },
    {
      name: 'Bodaibo (Russia)',
      region: t.mine4Region,
      slug: 'bodaibo',
      coordinates: [114.19, 57.85],
    },
    {
      name: 'Boddington (Australia)',
      region: t.mine5Region,
      slug: 'boddington',
      coordinates: [116.47, -32.8],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 11.5 },
    { name: COUNTRIES.russia, percent: 9.4 },
    { name: COUNTRIES.australia, percent: 8.8 },
    { name: COUNTRIES.canada, percent: 6.1 },
    { name: COUNTRIES.unitedStates, percent: 4.8 },
  ],
  important: true,
  // The sheet's three: the other metals the EU classes as conflict minerals alongside
  // gold — a supply-chain grouping, not a co-product relationship.
  related: ['tantalum', 'tin', 'tungsten'],
  video: { name: 'gold', poster: '/mine-my-phone/images/posters/gold.jpg' },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'camera'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 5, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: 'Albert Ansah',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'Albert Ansah',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
          credit: 'Albert Ansah',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'vertical',
          credit: 'Albert Ansah',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'vertical',
          credit: 'Albert Ansah',
        },
        {
          src: `${dir}/07.jpg`,
          orientation: 'horizontal',
          credit: 'Bloomberg / Getty',
        },
      ],
    },
  },
}
